import { useState, useEffect } from 'react';
import { fetchBannersBySection } from '../services/bannerService';

/**
 * Fetches CMS banners for a page section. Use hasDynamicBanner to branch layout:
 * with banner → image banner first, white title band; without → red gradient title only.
 */
export function usePageBanners(section) {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(!!section);

  useEffect(() => {
    if (!section) {
      setBanners([]);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);

    fetchBannersBySection(section).then((data) => {
      if (!cancelled) {
        setBanners(Array.isArray(data) ? data : []);
        setLoading(false);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [section]);

  const hasDynamicBanner = !loading && banners.length > 0;

  return {
    banners,
    loading,
    hasDynamicBanner,
    banner: banners[0],
  };
}
